import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {FilterPipe} from "./service/filterPipe";
import {FileUploadModule} from "ng2-file-upload";
import {Safe} from "./service/keep-html.pipe";
import { FooterComponent, NavbarComponent, } from './layouts';
import { TransformMoneyPipe } from "./pipe/transformMoney.pipe";
import { TransformCustomDatePipe } from "./pipe/transformCustomDate.pipe";
import { TransformPhonePipe } from "./pipe/transformPhone.pipe";
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';
import { PublicViewImageComponent } from "./components/public-view-image/public-view-image";
import { ErrorTextComponent } from "./components/error-text/error-text.component";
import { NewOTPComponent } from "./components/otp/otp.component";
import { FileSizePipe } from "./service/filesize.service";
import { AutoCompleteComponent } from "./components/auto-complete/auto-complete.component";
import { PagingComponent } from "./components/paging/paging.component";
import { FeatureMaintenanceComponent } from "./components/feature-maintenance/feature-maintenance.component";
import { FormCreateAppointmentComponent } from "./components/form-create-appointment/form-create-appointment.component";
import { CreateAppointmentPopupComponent } from "../profile-user/components/create-appointment-popup/create-appointment-popup.component";
import { InputDateComponent } from "./components/input-date/input-date";
import { InputNumberComponent } from "./components/input-number/input-number";
import { InputNoteComponent } from "./components/input-note/input-note.component";
import { TransformDateNullPipe } from "./pipe/transformDataNull.pipe";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    FileUploadModule,
    HttpClientModule,
    TranslateModule,
    NgbTooltipModule,
    NgbModalModule,
  ],
  declarations: [
    FilterPipe,
    Safe,
    FooterComponent,
    NavbarComponent,
    TransformCustomDatePipe,
    TransformMoneyPipe, TransformDateNullPipe,
    TransformPhonePipe, FileSizePipe,
    PagingComponent, 
    DropdownSearchComponent, AutoCompleteComponent,
    PublicViewImageComponent,
    ErrorTextComponent,
    NewOTPComponent,
    FeatureMaintenanceComponent,
    FormCreateAppointmentComponent,
    CreateAppointmentPopupComponent,
    InputDateComponent, InputNumberComponent, InputNoteComponent
  ],
  providers: [
  ],
  exports: [
    HttpClientModule,
    TranslateModule,
    NgbModalModule,
    ReactiveFormsModule,
    FileUploadModule,
    NgbTooltipModule,
    FooterComponent, NavbarComponent,
    TransformCustomDatePipe, TransformMoneyPipe, FileSizePipe, Safe,  FilterPipe, TransformDateNullPipe,
    PagingComponent, DropdownSearchComponent, AutoCompleteComponent, NewOTPComponent,
    ErrorTextComponent, FormCreateAppointmentComponent, CreateAppointmentPopupComponent,
    InputDateComponent, InputNumberComponent, InputNoteComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule{ }
